/* beautiful-react-hooks version: 0.35.0 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createCbSetterErrorProxy = function createCbSetterErrorProxy(errorMessage) {
  return new Proxy(Object.create(null), {
    get: function get(target, property) {
      if (property && typeof property === 'string' && property.slice(0, 2) === 'on') {
        return function () {
          throw new Error(errorMessage);
        };
      }

      return {
        error: errorMessage
      };
    }
  });
};

exports.default = createCbSetterErrorProxy;
